import React from 'react';

const NotFound: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h1 className="text-6xl font-extrabold animate__animated animate__fadeInUp">
          4<span className="text-red-500">0</span>4
        </h1>
        <p className="mt-4 text-xl font-medium animate__animated animate__fadeInUp animate__delay-1s">
          Oops! Page Not Found.
        </p>
        <p className="mt-4 text-lg text-gray-400 animate__animated animate__fadeInUp animate__delay-2s">
          Looks like you’re lost. We can’t find that page.
        </p>
        <div className="mt-6">
          <a
            href="/"
            className="inline-block px-6 py-3 bg-white text-indigo-600 rounded-full font-semibold text-lg hover:bg-gray-200 transform transition-all duration-300 hover:scale-105 animate__animated animate__fadeInUp animate__delay-3s"
          >
            Go back to Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
